import React, { useContext, useState } from "react";
import Swal from "sweetalert2";
import LoadingIcon from "../../images/Loading_icon.gif";
import { AppContext } from "../../contexts/AppContext";
import { UrlContext } from "../../contexts/UrlContext";

export default function ReviewTab({
  setActiveTab,
  data,
  setExperts,
  setProject_id,
  projEditing,
}) {
  const {
    updateProjects,
    setUpdateProjects,
    setAllCustomisedLists,
    setAllProjects,
  } = useContext(AppContext);
  const [initializePopup, setInitializePopup] = useState(false);
  const [updatePopup, setUpdatePopup] = useState(false);
  const { API_URL } = useContext(UrlContext);
  const projectInitializeHandler = () => {
    setInitializePopup(true);
    const url = `${API_URL}project-initialized`;
    const ephToken = localStorage.getItem("eph-token");
    const token = JSON.parse(ephToken).value;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setInitializePopup(false);
        if (data.status === "success" && data.experts.length === 0) {
          setUpdateProjects(!updateProjects);
          const url = `${API_URL}get-all-projects`;
          fetch(url, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          })
            .then((res) => res.json())
            .then((data) => {
              setAllProjects(data.projects);
              setAllCustomisedLists(data.customisedLists);
            })
            .catch((err) => {
              console.log(err);
            });
          Swal.fire({
            title: "Success!",
            text: "Project has been initialized. No suggested experts found for this project.",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            window.location.href = "/app/ProjectsOverview/";
          });
        } else if (data.status === "success" && data.experts.length > 0) {
          setUpdateProjects(!updateProjects);
          const url = `${API_URL}get-all-projects`;
          fetch(url, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          })
            .then((res) => res.json())
            .then((data) => {
              setAllProjects(data.projects);
              setAllCustomisedLists(data.customisedLists);
            })
            .catch((err) => {
              console.log(err);
            });
          Swal.fire({
            title: "Success!",
            text: "Project has been initialized. Suggested Experts found for this project.",
            icon: "success",
            confirmButtonText: "OK",
          });
          setExperts(data.experts);
          setProject_id(data.project_id);
        } else if (data.status === "error" && data.message) {
          console.log(data.message);
          Swal.fire({
            title: "Error!",
            text: data.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        } else
          Swal.fire({
            title: "Error!",
            text: "Something went wrong",
            icon: "error",
            confirmButtonText: "OK",
          });
      });
  };

  const projectUpdateHandler = () => {
    setUpdatePopup(true);
    const url = `${API_URL}update-project-details`;
    const ephToken = localStorage.getItem("eph-token");
    const token = JSON.parse(ephToken).value;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setUpdatePopup(false);
        if (data.status === "success") {
          setUpdateProjects(!updateProjects);
          Swal.fire({
            title: "Success!",
            text: "Project has been updated.",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            window.location.href = "/app/ProjectsOverview/";
          });
          // } else if (data.status === "success" && data.experts.length > 0) {
          //   setUpdateProjects(!updateProjects);
          //   Swal.fire({
          //     title: "Success!",
          //     text: "Project has been initialized. Suggested Experts found for this project.",
          //     icon: "success",
          //     confirmButtonText: "OK",
          //   });
          //   setExperts(data.experts);
          //   setProject_id(data.project_id);
        } else if (data.status === "error" && data.message) {
          console.log(data.message);
          Swal.fire({
            title: "Error!",
            text: data.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        } else
          Swal.fire({
            title: "Error!",
            text: "Something went wrong",
            icon: "error",
            confirmButtonText: "OK",
          });
      });
  };

  return (
    <>
      <fieldset>
        <div className="form-card review-project-setup">
          <h4 className="text-muted" style={{fontWeight: 'bold'}}><b>Project Details</b></h4>
          <div className="row">
            <p className="col-3 text-muted">Lead Email</p>
            <p className="col-9">{data.leadEmail}</p>
          </div>
          {data.additionalEmails.length > 0 && (
            <div className="row">
              <p className="col-3 text-muted">Additional Email</p>
              <p className="col-9">
                {data.additionalEmails.map((value, index) => {
                  const isLastElement = index === data.additionalEmails.length - 1;
                  return (
                    <span key={index}>
                      {value}
                      {!isLastElement && "; "}
                    </span>
                  );
                })}
              </p>
            </div>
          )}
          <div className="row">
            <p className="col-3 text-muted">Client Owner</p>
            <p className="col-9">{data.clientOwner}</p>
          </div>
          <div className="row">
            <p className="col-3 text-muted">Project Name</p>
            <p className="col-9">{data.projectName}</p>
          </div>
          <div className="row">
            <p className="col-3 text-muted">Project Description</p>
            <p className="col-9"
                dangerouslySetInnerHTML={{ __html: data.projectDescription }}></p>
          </div>
          <div className="row">
            <p className="col-3 text-muted">Publish</p>
            {data.public ? (
              <p className="col-9">Yes</p>
            ) : (
              <p className="col-9">No</p>
            )}
          </div>
          <div className="row">
            <p className="col-3 text-muted">Profile Type</p>
            <p className="col-9">
              {data.projectConsultantType === "con"
                ? "Consultants (Long-term project support)"
                : data.projectConsultantType === "exp"
                ? "Experts (Expert call)"
                : ""}
            </p>
          </div>
          <div className="row">
            <p className="col-3 text-muted">Proposal</p>
            <p className="col-9">
              {data.proposal ? "Yes"
                : "No"}
            </p>
          </div>
          <div className="row">
            <p className="col-3 text-muted">Region</p>
            <p className="col-9">{data.projectRegion}</p>
          </div>
          <div className="row">
            <p className="col-3 text-muted">Country</p>
            <p className="col-9">{data.projectLocation}</p>
          </div>
          <div className="row">
            <p className="col-3 text-muted">Industy Preference</p>
            <p className="col-9">{data.projectIndustyPreference}</p>
          </div>
          <div className="row">
            <p className="col-3 text-muted">Industy</p>
            <p className="col-9">
              {Array.isArray(data.projectIndustyPreferenceList) ? (
                data.projectIndustyPreferenceList.map((industry, index) => {
                  if (index < data.projectIndustyPreferenceList.length - 1) {
                    return <span key={index}>{industry.name}, </span>;
                  } else {
                    return <span key={index}>{industry.name}</span>;
                  }
                })
              ) : (
                <span>{data.projectIndustyPreferenceList || "No industry preference"}</span>
              )}
            </p>
          </div>
          <div className="row">
            <p className="col-3 text-muted">Daily Budget</p>
            <p className="col-9">{data.projectDailyBudget}</p>
          </div>
          <div className="row">
            <p className="col-3 text-muted">Project Category</p>
            <p className="col-9">{data.projectCategory}</p>
          </div>

          <br/>
          <h4 className="text-muted mt-3" style={{fontWeight: 'bold'}}><b>Profile Details</b></h4>
          <div className="row">
            <p className="col-3 text-muted">Seniority</p>
            <p className="col-9">
              {data.projectSeniority?.map((seniority, index) => {
                if (index < data.projectSeniority?.length - 1) {
                  return <span key={index}>{seniority.name}, </span>;
                } else {
                  return <span key={index}>{seniority.name}</span>;
                }
              })}
            </p>
          </div>
          <div className="row">
            <p className="col-3 text-muted">Suggested Skills</p>
            <p className="col-9">
              {data.projectSuggestedSkills.map((skill, index) => {
                if (index < data.projectSuggestedSkills?.length - 1) {
                  return <span key={index}>{skill}, </span>;
                } else {
                  return <span key={index}>{skill}</span>;
                }
              })}
            </p>
          </div>
          <div className="row">
            <p className="col-3 text-muted">Other Skills</p>
            <p className="col-9">
              {data.projectSkillsRequirements.map((skill, index) => {
                if (index < data.projectSkillsRequirements?.length - 1) {
                  return <span key={index}>{skill.value}, </span>;
                } else {
                  return <span key={index}>{skill.value}</span>;
                }
              })}
            </p>
          </div>
          {data.screeningQuestions && (
            <div className="row">
              <p className="col-3 text-muted">Screening Questions</p>
              <p className="col-9">
                {data.screeningQuestions.map((questions, index) => {
                  return (
                    <p key={index}>
                      {questions.question}{" "}
                      <span style={{ fontWeight: "bold" }}>Question Type:</span>{" "}
                      {questions.answerType}
                    </p>
                  );
                })}
              </p>
            </div>
          )}
          <div className="row">
            <p className="col-3 text-muted">Language</p>
            <p className="col-9">
              {data.projectLanguages.map((language, index) => {
                const label = language.requirement
                  ? `${language.name} (${language.requirement})`
                  : language.name;

                if (index < data.projectLanguages.length - 1) {
                  return <span key={index}>{label}, </span>;
                } else {
                  return <span key={index}>{label}</span>;
                }
              })}
            </p>
          </div>
          <div className="row">
            <p className="col-3 text-muted">Project Start Date</p>
            <p className="col-9">{data.projectStartDate}</p>
          </div>
          <div className="row">
            <p className="col-3 text-muted">Deadline</p>
            <p className="col-9">{data.projectDeadline}</p>
          </div>
          <div className="row">
            <p className="col-3 text-muted">Project Duration</p>
            <p className="col-9">{data.projectDuration}</p>
          </div>
          <div className="row">
            <p className="col-3 text-muted">Type of Employment</p>
            <p className="col-9">
              {data.projectTypeOfEmployment}
              {data.projectTypeOfEmployment === "Hybrid" && (
                <span>
                  {data.projectRemoteOption && (
                    <span> (Remote {data.projectRemoteOption}%,</span>
                  )}
                  {data.projectOnsiteOption && (
                    <span> Onsite {data.projectOnsiteOption}%)</span>
                  )}
                </span>
              )}
            </p>
          </div>
          <div className="row">
            <p className="col-3 text-muted">Utilization Intensity</p>
            <p className="col-9">{data.utilizationIntensity}%</p>
          </div>
          <div className="row">
            <p className="col-3 text-muted">Total Days</p>
            <p className="col-9">{data.totalDays}</p>
          </div>
        </div>
        {projEditing ? (
          <input
            onClick={projectUpdateHandler}
            type="submit"
            className="next action-button"
            value="Update"
          />
        ) : (
          <input
            onClick={projectInitializeHandler}
            type="submit"
            className="next action-button"
            value="Initialize"
          />
        )}
        <input
          onClick={() => setActiveTab("profileDetails")}
          type="button"
          className="previous action-button-previous"
          defaultValue="Previous"
        />
      </fieldset>

      {initializePopup && (
        <div className="linkedin-popup-wrapper">
          <div className="tab-pane fade show linkedin-div">
            <center>
              <p style={{ fontSize: "18px" }}>Initializing project...</p>
              <br />
              <img
                src={LoadingIcon}
                alt=""
                style={{ width: "50px", marginRight: "5px" }}
              />
            </center>
          </div>
        </div>
      )}
      {updatePopup && (
        <div className="linkedin-popup-wrapper">
          <div className="tab-pane fade show linkedin-div">
            <center>
              <p style={{ fontSize: "18px" }}>Updating project...</p>
              <br />
              <img
                src={LoadingIcon}
                alt=""
                style={{ width: "50px", marginRight: "5px" }}
              />
            </center>
          </div>
        </div>
      )}
    </>
  );
}
